import { render } from "./EventStats.vue?vue&type=template&id=3d360931&ts=true"
import script from "./EventStats.vue?vue&type=script&lang=ts"
export * from "./EventStats.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__